<template>
  <div class="SessionsPage">
    <v-container>
      <v-row class="mb-8 mt-5" align="center" justify="space-between">
        <div class="d-flex align-center">
          <v-icon left color="primary" @click="goToAgent()">mdi-chevron-left</v-icon>
          <h1 class="text-h5 font-weight-medium">{{this.channelTypeView[this.channelType]}} Sessions</h1>
        </div>
      </v-row>

      <chat-session-list
        :sessions="sessions"
        :loading="sessionsListLoading"
        :show-load-more="canLoadMoreSession"
        @load-more="loadMoreSessions"
      />
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: customerGetters } = createNamespacedHelpers('customer');
const {
  mapGetters: AIChatGetters,
  mapActions: AIChatActions,
  mapMutations: AIChatMutations,
} = createNamespacedHelpers('AIChat');

import constants from '@/util/constants';
import * as moment from 'moment/moment';
import ChatSessionList from '@/views/ai-chat/components/chat-session-list.vue';

export default {
  name: 'CommunicationChannelsSessionsPage',
  components: {
    ChatSessionList,
  },
  data() {
    return {
      sessionPage: 0,
      publicPath: constants.isDevelopment ? '' : '',
      canLoadMoreSession: true,
      channelType: null,
      workspaceId: null,
      channelTypeView: {
        'slack': 'Slack',
        'sms': 'Twilio SMS',
        'incoming_event': 'Incoming Event'
      }
    };
  },
  computed: {
    ...customerGetters({
      customer: 'CUSTOMER',
      selectedCustomer: 'SELECTED_CUSTOMER',
    }),
    ...AIChatGetters({
      sendMessageLoading: 'SEND_MESSAGE_LOADING',
      sessions: 'COMMUNICATION_CHANNEL_SESSIONS_LIST',
      sessionsListLoading: 'COMMUNICATION_CHANNEL_SESSIONS_LIST_LOADING',
    }),
  },
  methods: {
    ...AIChatActions(['sendMessage', 'getSessions', 'getSessionsByCommunicationChannel']),
    ...AIChatMutations({
      setSessions: 'SET_COMMUNICATION_CHANNEL_SESSIONS_LIST',
    }),
    getTime(date) {
      return moment(date).fromNow();
    },
    async loadMoreSessions() {
      this.sessionPage += 1;
      const preLoadCount = this.sessions.length;
      await this.getSessionsByCommunicationChannel({ channelType: this.channelType, workspaceId: this.workspaceId, page: this.sessionPage, push: true });
      const postLoad = this.sessions.length;
      if (postLoad === preLoadCount) {
        this.canLoadMoreSession = false;
      }
    },
    async getInfo() {
      await this.getSessionsByCommunicationChannel({ page: this.sessionPage, channelType: this.channelType, workspaceId: this.workspaceId });
    },
    goToAgent() {
      this.$router.push({ path: `/agents/${this.workspaceId}` });
    }
  },
  watch: {
    async 'selectedCustomer.customer_id'() {
      this.setSessions([]);
      await this.getInfo();
    },
  },
  async mounted() {
    this.channelType = this.$route.query.channelType;
    this.workspaceId = this.$route.params.workspaceId;
    await this.getInfo();
  },
};
</script>
